import { Container, i18n, utils } from "@common";
import { routerPaths } from './tool';
import "./index.less";

const Reporting = () => {

    const handleSectionClick = (type) => {
        switch (type) {
            case "StaffAccessReview":
                utils.redirectTo(routerPaths.staffAcessReview);
                break;
            case "ApplicationUsage":
                utils.redirectTo(routerPaths.applicationUsage);
                break;
            case "AuditLogs":
                utils.redirectTo(routerPaths.auditlogs);
                break;
            case "SignInLogs":
                utils.redirectTo(routerPaths.signInLogs);
                break;
            case "SuspiciousActivity":
                utils.redirectTo(routerPaths.suspiciousActivity);
                break;
        }
    };

    return (
        <Container className="container">
            <div className="page">
                <div className='diamond' onClick={() => handleSectionClick('StaffAccessReview')}>
                    <div className="flex-column flex-align-center flex-justify-center">
                        <icon className="fia-globe-access"></icon>
                        <div className="text">{i18n.get('CIS_Admin_Reporting_StaffAccessReview_Entry')}</div>
                    </div>
                </div>
                <div className='diamond' onClick={() => handleSectionClick('ApplicationUsage')}>
                    <div className="flex-column flex-align-center flex-justify-center">
                        <icon id='reportingIcon' className="fia-chart-line-fill"></icon>
                        <div className="text">{i18n.get('CIS_Admin_Reporting_ApplicationUsage_Entry')}</div>
                    </div>
                </div>
                <div className='diamond' onClick={() => handleSectionClick('AuditLogs')}>
                    <div className="flex-column flex-align-center flex-justify-center">
                        <icon id='reportingIcon' className="fia-log-file"></icon>
                        <div className="text">{i18n.get('CIS_Admin_Reporting_AuditLogs_Entry')}</div>
                    </div>
                </div>
                <div className='diamond' onClick={() => handleSectionClick('SignInLogs')}>
                    <div className="flex-column flex-align-center flex-justify-center">
                        <icon id='reportingIcon' className="fia-sign-in"></icon>
                        <div className="text">{i18n.get('CIS_Admin_Reporting_Sign_inLogs_Entry')}</div>
                    </div>
                </div>
                <div className='diamond' onClick={() => handleSectionClick('SuspiciousActivity')}>
                    <div className="flex-column flex-align-center flex-justify-center">
                        <icon id='reportingIcon' className="fia-thunder"></icon>
                        <div className="text">{i18n.get('CIS_Admin_Reporting_SuspiciousActivity_Entry')}</div>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default Reporting;